export default "__VITE_PUBLIC_ASSET__22356705__"